// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";
import merge from "lodash/merge";

export interface XCheckoutStateType {
    shipWhenComplete: string;
    pickupWhenComplete: string;
    useOneTimeAddress: boolean;
    useBillingAddress: boolean;
    isAddressEditing: boolean;
    isPaymentProfileExpired: boolean;
    taxExempt: boolean;
    taxExemptCertificateNumber: string;
}

export const initialCheckoutState: XCheckoutStateType = {
    shipWhenComplete: "false",
    pickupWhenComplete: "false",
    useOneTimeAddress: false,
    useBillingAddress: false,
    isAddressEditing: false,
    isPaymentProfileExpired: false,
    taxExempt: false,
    taxExemptCertificateNumber: "",
};

const reducer = {
    "xCheckout/Update": (draft: Draft<XCheckoutStateType>, action: { data: Partial<XCheckoutStateType> }) => {
        draft = merge(draft, action.data);
    },
    "xCheckout/Reset": (draft: Draft<XCheckoutStateType>) => {
        draft.shipWhenComplete = "false";
        draft.pickupWhenComplete = "false";
        draft.useOneTimeAddress = false;
        draft.useBillingAddress = false;
        draft.isAddressEditing = false;
        draft.isPaymentProfileExpired = false;
        draft.taxExempt = false;
        draft.taxExemptCertificateNumber = "";
    },
};

const xCheckout = createTypedReducerWithImmer(initialCheckoutState, reducer);

(reducers as any).xCheckout = xCheckout;

export type xCheckoutState = {
    xCheckout: XCheckoutStateType;
} & ApplicationState;

type xCheckoutReducers = {
    [key: string]: typeof xCheckout;
};

export type xCheckoutActions = Parameters<xCheckoutReducers[keyof xCheckoutReducers]>[1] | AnyAction;
